import * as api from '../api';

const dataUrl = '/2.0/coach/favorite';

export const getAll = async pageSize =>
    await api.get(`${dataUrl}?pageSize=${pageSize}`);

export const get = async id => await api.get(`${dataUrl}/${id}`);

export const copy = async id => await api.post(`${dataUrl}/copy/${id}`);

export const create = async () => await api.post(dataUrl);

export const remove = async id => await api.post(`${dataUrl}/delete/${id}`);

export const saveWorkoutCombo = async workoutCombo =>
    await api.put(`${dataUrl}/save/${workoutCombo.id}`, workoutCombo);

export const saveComboSetExercises = async workoutComboExercises =>
    await api.put(
        `${dataUrl}/workoutComboExercise/save`,
        workoutComboExercises
    );

export const deleteSetExercise = async (setId, exId) =>
    await api.post(`${dataUrl}/workoutComboExercise/delete/${setId}/${exId}`);
